import React from 'react';
import clsx from 'clsx';

import styles from './Badge.module.scss';

export default function Badge({
	className: classNameProp,
	text,
	variant,
	size
}) {
	return (
		<span
			className={clsx(
				styles.root,
				classNameProp,
				styles[size],
				styles[variant]
			)}
		>
			{text}
		</span>
	);
}

export const BadgeStyles = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary'
};

export const BadgeSizes = {
	SMALL: 'sm',
	MEDIUM: 'md'
};
